import type { TodoItem } from "@zero/types/todo";
import { isTodoCompleted, isTodoInProgress } from "../utils/todoRights";

export type KanbanColumnId = "todo" | "in-progress" | "done";

export interface KanbanColumn {
  id: KanbanColumnId;
  title: string;
  getTaskIds: (todos: TodoItem[]) => string[];
}

export const KANBAN_COLUMNS: KanbanColumn[] = [
  {
    id: "todo",
    title: "待办",
    getTaskIds: (todos) => todos.filter((t) => t.status === "pending").map((t) => t.id),
  },
  {
    id: "in-progress",
    title: "进行中",
    getTaskIds: (todos) => todos.filter(isTodoInProgress).map((t) => t.id),
  },
  {
    id: "done",
    title: "已完成",
    getTaskIds: (todos) => todos.filter(isTodoCompleted).map((t) => t.id),
  },
];

export const getColumnById = (id: string): KanbanColumn | undefined => {
  return KANBAN_COLUMNS.find((col) => col.id === id);
};
